module.exports = __webpack_public_path__ + "img/client-gustazos.5169669f.png";